import config from "../../lib/config"

export const PdfViewer = ({fileName}) => {

	return (
		<div>
            <iframe src={`${config.apiBaseUrl}/pdf/${fileName}.pdf`} style={{width: '100%', height: '100%'}}></iframe>
        </div>)
}